import { render, staticRenderFns } from "./ProjectClone.vue?vue&type=template&id=646b2a9c"
import script from "./ProjectClone.vue?vue&type=script&lang=js"
export * from "./ProjectClone.vue?vue&type=script&lang=js"
import style0 from "./ProjectClone.vue?vue&type=style&index=0&id=646b2a9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports